import { getTaskQueryFromContext } from "../../../context-options/utils"
import { TasksQueryParams } from "../../../tasks/api"
import { TasksViewOptions } from "../../../tasks/components/TasksViewSelect"
import { AppMainContextType, AppSubContextType } from "../../../types/app-context"
import { Status } from "../../../types/common"

export const makeTaskListQuery = (
  context: AppMainContextType | AppSubContextType | null,
  view: TasksViewOptions
): TasksQueryParams => {
  if (view === "completed") {
    return {
      links: "true",
      files: "true",
      archived: "false",
      status: [Status.COMPLETED],
      ...getTaskQueryFromContext(context),
    }
  }

  if (view === "archived") {
    return {
      links: "true",
      files: "true",
      ...getTaskQueryFromContext(context),
      archived: "true",
    }
  }

  if (view === "rejected") {
    return {
      links: "true",
      files: "true",
      archived: "false",
      status: [Status.REJECTED],
      ...getTaskQueryFromContext(context),
    }
  }

  if (view === "currentAndFuture") {
    return {
      links: "true",
      files: "true",
      archived: "false",
      status: [Status.NOT_STARTED, Status.IN_PROGRESS],
      ...getTaskQueryFromContext(context),
    }
  }

  return getTaskQueryFromContext(context)
}
